import { ref, computed, watch, useCssModule, onBeforeMount } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useListNavigation } from "./assets/index-BLMLj0sV.js";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as usePlacementProp } from "./assets/XDropdown-Bc_0Fycm.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import { useElementVisibility } from "@vueuse/core";
import { X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import XTooltip from "./XTooltip.js";
import XEllipsis from "./XEllipsis.js";
import XButton from "./XButton.js";
import { B as BaseLink } from "./assets/BaseLink-KuovKwoP.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/index-DKxr0Yto.js";
import "./assets/index-4vIud5LZ.js";
import "@floating-ui/dom";
import "@fortawesome/vue-fontawesome";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./assets/index-Ca8wHgNc.js";
import "./assets/index-D0Qy8ijJ.js";
import "./XSpinner.js";
function useScroll(options = {}) {
  const { scrollRef = ref(null), isHorizontal = ref(true), scrollPixels = 100, callBack } = options;
  const isScrollRefVisible = useElementVisibility(scrollRef);
  const isScrollAtStart = ref(true);
  const isScrollAtEnd = ref(false);
  const hasScroll2 = computed(() => {
    var _a, _b, _c, _d;
    if (!isScrollRefVisible.value) return false;
    const hasVerticalScroll = ((_a = scrollRef.value) == null ? void 0 : _a.scrollHeight) > ((_b = scrollRef.value) == null ? void 0 : _b.clientHeight);
    const hasHorizontalScroll = ((_c = scrollRef.value) == null ? void 0 : _c.scrollWidth) > ((_d = scrollRef.value) == null ? void 0 : _d.clientWidth);
    return hasVerticalScroll || hasHorizontalScroll;
  });
  const isScrollMoving = computed(() => !isScrollAtStart.value && !isScrollAtEnd.value);
  const isScrollNotAtStart = computed(() => isScrollMoving.value || isScrollAtEnd.value);
  const isScrollNotAtEnd = computed(() => isScrollMoving.value || isScrollAtStart.value);
  const scrollNext = () => {
    if (scrollRef.value) {
      scrollRef.value.scrollBy({
        [isHorizontal.value ? "left" : "top"]: scrollPixels,
        behavior: "smooth"
      });
    }
  };
  const scrollPrev = () => {
    if (scrollRef.value) {
      scrollRef.value.scrollBy({
        [isHorizontal.value ? "left" : "top"]: -scrollPixels,
        behavior: "smooth"
      });
    }
  };
  function handleScrollHorizontal() {
    isScrollAtStart.value = scrollRef.value.scrollLeft === 0;
    isScrollAtEnd.value = scrollRef.value.scrollLeft + scrollRef.value.clientWidth === scrollRef.value.scrollWidth;
  }
  function handleScrollVertical() {
    isScrollAtStart.value = scrollRef.value.scrollTop === 0;
    isScrollAtEnd.value = scrollRef.value.scrollTop + scrollRef.value.clientHeight === scrollRef.value.scrollHeight;
  }
  function handleScroll() {
    if (scrollRef.value) {
      if (isHorizontal.value) {
        handleScrollHorizontal();
      } else {
        handleScrollVertical();
      }
      if (callBack && typeof callBack === "function") {
        callBack();
      }
    }
  }
  return {
    isScrollAtStart,
    isScrollAtEnd,
    isScrollMoving,
    isScrollNotAtStart,
    isScrollNotAtEnd,
    hasScroll: hasScroll2,
    isScrollRefVisible,
    scrollNext,
    scrollPrev,
    handleScroll
  };
}
function useActiveBar(options = {}) {
  const {
    scrollRef = ref(null),
    currentNavigableNode = ref(null),
    isHorizontal = ref(true)
  } = options;
  const activeBarRef = ref(null);
  const { isScrollRefVisible } = useScroll({
    scrollRef,
    isHorizontal
  });
  function setActiveBarPositionHorizontal(validElementNode) {
    var _a;
    const containerOffset = ((_a = scrollRef.value) == null ? void 0 : _a.scrollLeft) || 0;
    const { offsetLeft = 0, offsetWidth = 0 } = validElementNode;
    activeBarRef.value.style.left = `${offsetLeft - containerOffset}px`;
    activeBarRef.value.style.width = `${offsetWidth}px`;
  }
  function setActiveBarPositionVertical(validElementNode) {
    var _a;
    const containerOffset = ((_a = scrollRef.value) == null ? void 0 : _a.scrollTop) || 0;
    const { offsetTop = 0, offsetHeight = 0 } = validElementNode;
    activeBarRef.value.style.top = `${offsetTop - containerOffset}px`;
    activeBarRef.value.style.height = `${offsetHeight}px`;
  }
  function setActiveBarPosition(customElement = null) {
    setTimeout(() => {
      var _a;
      if (activeBarRef.value && ((_a = activeBarRef.value) == null ? void 0 : _a.style)) {
        const validElementNode = customElement || currentNavigableNode.value || {};
        if (isHorizontal.value) {
          setActiveBarPositionHorizontal(validElementNode);
        } else {
          setActiveBarPositionVertical(validElementNode);
        }
      }
    }, 0);
  }
  watch(
    () => isScrollRefVisible.value,
    () => {
      setActiveBarPosition();
    }
  );
  return {
    activeBarRef,
    setActiveBarPosition
  };
}
function useTabClasses(props, hasScroll2) {
  const $style = useCssModule();
  function getTabClasses(tab2) {
    return {
      [$style.isActive]: tab2.active,
      [$style.isDisabled]: tab2.disabled
    };
  }
  const tabClasses = computed(() => ({
    [$style.hasScroll]: hasScroll2.value,
    [$style.sizeSmall]: props.size === "sm",
    [$style.withoutLine]: props.withoutLine,
    [$style.isVertical]: props.orientation === "vertical"
  }));
  return {
    getTabClasses,
    tabClasses
  };
}
function useTabsControl(options) {
  const { props, emit } = options;
  const currentTabName = ref(props.activeTab);
  function setActiveTab(tabName) {
    currentTabName.value = tabName;
    emit("update:activeTab", currentTabName.value);
  }
  function isCurrentTab(tab2) {
    return tab2.name === currentTabName.value;
  }
  function canChangeTab(tab2, event, callBack) {
    return () => {
      if (tab2 && !(tab2 == null ? void 0 : tab2.active) && !(tab2 == null ? void 0 : tab2.disabled) && !(tab2 == null ? void 0 : tab2.blocked) && !isCurrentTab(tab2)) {
        callBack();
      } else {
        event == null ? void 0 : event.preventDefault();
      }
    };
  }
  function changeTab(tab2, event) {
    canChangeTab(tab2, event, () => {
      setActiveTab(tab2.name);
      emit("change", {
        ...tab2,
        active: isCurrentTab(tab2)
      });
    })();
  }
  const computedTabs = computed(() => {
    return props.items.filter((tab2) => !(tab2 == null ? void 0 : tab2.hidden)).map((tab2) => {
      const newTab = { ...tab2 };
      newTab.active = isCurrentTab(tab2);
      return newTab;
    });
  });
  const initialTabIndex = computed(
    () => props.activeTab ? computedTabs.value.findIndex((tab2) => tab2.name === props.activeTab) : 0
  );
  onBeforeMount(() => {
    if (!currentTabName.value && computedTabs.value.length > 0) {
      setActiveTab(computedTabs.value[0].name);
    }
  });
  return {
    computedTabs,
    currentTabName,
    initialTabIndex,
    changeTab,
    canChangeTab
  };
}
function useTabType() {
  const controlTypes = {
    link: "BaseLink",
    button: "button"
  };
  function getTabType(tab2) {
    if (!tab2.to || tab2.disabled) {
      return controlTypes.button;
    }
    return controlTypes.link;
  }
  function isTabTypeButton(tab2) {
    return getTabType(tab2) === controlTypes.button;
  }
  return {
    getTabType,
    isTabTypeButton
  };
}
const xTabs = "_xTabs_1qqat_1";
const withoutLine = "_withoutLine_1qqat_26";
const hasScroll = "_hasScroll_1qqat_29";
const activeBar = "_activeBar_1qqat_29";
const sizeSmall = "_sizeSmall_1qqat_32";
const isVertical = "_isVertical_1qqat_38";
const scroll = "_scroll_1qqat_50";
const tabList = "_tabList_1qqat_54";
const arrow = "_arrow_1qqat_66";
const tab = "_tab_1qqat_54";
const isActive = "_isActive_1qqat_77";
const isDisabled = "_isDisabled_1qqat_77";
const scrollContainer = "_scrollContainer_1qqat_86";
const arrowRight = "_arrowRight_1qqat_128";
const tabTitle = "_tabTitle_1qqat_169";
const tabTooltip = "_tabTooltip_1qqat_174";
const style0 = {
  xTabs,
  withoutLine,
  hasScroll,
  activeBar,
  sizeSmall,
  isVertical,
  scroll,
  tabList,
  arrow,
  tab,
  isActive,
  isDisabled,
  scrollContainer,
  arrowRight,
  tabTitle,
  tabTooltip
};
const { createPlacementProp } = usePlacementProp();
const { placement } = createPlacementProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XTabs",
  components: { XIcon, XTooltip, XButton, BaseLink, XEllipsis }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    /**
     * Array of tab objects, where each object represents a tab.
     * @type {Tab[]}
     */
    items: {
      type: Array,
      default: () => [],
      validator: (tabs) => {
        const requiredProps = ["name", "title"];
        return tabs.every(
          (tab2) => requiredProps.every((prop) => {
            if (!(prop in tab2)) {
              console.error(
                `One of the objects in prop items does not contain the property ${prop}`,
                tab2
              );
              return false;
            }
            return true;
          })
        );
      }
    },
    activeTab: {
      type: String,
      default: ""
    },
    withoutLine: {
      type: Boolean,
      default: false
    },
    orientation: {
      type: String,
      default: "horizontal",
      validation: (orientation) => ["horizontal", "vertical"].includes(orientation)
    },
    size: {
      type: String,
      default: "",
      validation: (size) => ["", "sm"].includes(size)
    },
    tooltipPlacement: placement,
    ...createTestIdProp()
  },
  emits: ["change", "click:tab", "update:activeTab"],
  setup(__props, { emit }) {
    const props = __props;
    const itemsListRef = ref([]);
    const tabsHeaderElement = ref(null);
    const scrollRef = ref(null);
    const { formatTestId } = setupTestId(props);
    const ariaOrientation = computed(() => props.orientation);
    const isHorizontal = computed(() => props.orientation === "horizontal");
    const { computedTabs, changeTab, initialTabIndex, canChangeTab } = useTabsControl({
      props,
      emit
    });
    const { handleNavigationKeyboard, handleNavigationByItemIndex, currentNavigableNode } = useListNavigation({
      itemsList: computed(() => props.items),
      itemsListRef,
      horizontal: isHorizontal.value,
      initialPosition: initialTabIndex.value,
      callBack: (tab2, event) => {
        canChangeTab(tab2, event, () => {
          changeTab(tab2, event);
          setActiveBarPosition();
        })();
      }
    });
    const { activeBarRef, setActiveBarPosition } = useActiveBar({
      scrollRef,
      currentNavigableNode,
      isHorizontal
    });
    const { isScrollNotAtStart, isScrollNotAtEnd, hasScroll: hasScroll2, scrollNext, scrollPrev, handleScroll } = useScroll({
      scrollRef,
      isHorizontal,
      callBack: setActiveBarPosition
    });
    const { getTabClasses, tabClasses } = useTabClasses(props, hasScroll2);
    const { getTabType, isTabTypeButton } = useTabType();
    const navButtonSize = computed(() => {
      return props.size === "sm" ? "xs" : "sm";
    });
    function hasTooltip(tab2) {
      return !!(tab2 == null ? void 0 : tab2.tooltipText);
    }
    function getTabDataIndex(tab2, index) {
      return !tab2.disabled ? index : null;
    }
    function getTabTarget(tab2) {
      return !isTabTypeButton(tab2) && "_self";
    }
    function getTabindex(tab2) {
      return tab2.active && !(tab2 == null ? void 0 : tab2.disabled) ? 0 : -1;
    }
    function handleChangeTab(tab2, index, event) {
      emit("click:tab", tab2);
      canChangeTab(tab2, event, () => {
        handleNavigationByItemIndex(index);
      })();
    }
    function getTabDataTestId(tab2) {
      const defaultTabDataTestId = `${tab2.name}-tab`;
      return tab2.dataTestId || formatTestId(defaultTabDataTestId);
    }
    watch(
      () => initialTabIndex.value,
      (itemIndex) => {
        handleNavigationByItemIndex(itemIndex);
      }
    );
    return { __sfc: true, createPlacementProp, placement, createTestIdProp, setupTestId, props, emit, itemsListRef, tabsHeaderElement, scrollRef, formatTestId, ariaOrientation, isHorizontal, computedTabs, changeTab, initialTabIndex, canChangeTab, handleNavigationKeyboard, handleNavigationByItemIndex, currentNavigableNode, activeBarRef, setActiveBarPosition, isScrollNotAtStart, isScrollNotAtEnd, hasScroll: hasScroll2, scrollNext, scrollPrev, handleScroll, getTabClasses, tabClasses, getTabType, isTabTypeButton, navButtonSize, hasTooltip, getTabDataIndex, getTabTarget, getTabindex, handleChangeTab, getTabDataTestId, XIcon, XTooltip, XEllipsis, XButton };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_vm.$style.xTabs, _setup.tabClasses], attrs: { "data-testid": _setup.formatTestId() } }, [_setup.hasScroll ? _c(_setup.XButton, { directives: [{ name: "show", rawName: "v-show", value: _setup.isScrollNotAtStart, expression: "isScrollNotAtStart" }], class: _vm.$style.arrow, attrs: { "data-testid": _setup.formatTestId("prevButton"), "size": _setup.navButtonSize, "border-radius": "circle", "design": "text" }, on: { "click": function($event) {
    return _setup.scrollPrev();
  } } }, [_c(_setup.XIcon, { attrs: { "icon": "chevron-left" } })], 1) : _vm._e(), _setup.hasScroll ? _c(_setup.XButton, { directives: [{ name: "show", rawName: "v-show", value: _setup.isScrollNotAtEnd, expression: "isScrollNotAtEnd" }], class: [_vm.$style.arrow, _vm.$style.arrowRight], attrs: { "data-testid": _setup.formatTestId("nextButton"), "size": _setup.navButtonSize, "border-radius": "circle", "design": "text" }, on: { "click": function($event) {
    return _setup.scrollNext();
  } } }, [_c(_setup.XIcon, { attrs: { "icon": "chevron-right" } })], 1) : _vm._e(), _c("div", { class: _vm.$style.scrollContainer }, [_c("div", { ref: "activeBarRef", class: _vm.$style.activeBar, attrs: { "data-testid": _setup.formatTestId("activeBar") } }), _c("div", { ref: "scrollRef", class: _vm.$style.scroll, attrs: { "data-testid": _setup.formatTestId("scroll") }, on: { "scroll": _setup.handleScroll } }, [_c("div", { ref: "tabsHeaderElement", class: _vm.$style.tabList, attrs: { "aria-orientation": _setup.ariaOrientation, "role": "tablist" } }, _vm._l(_setup.computedTabs, function(tab2, index) {
    return _c(_setup.getTabType(tab2), { key: index, ref: "itemsListRef", refInFor: true, tag: "Component", class: [_vm.$style.tab, _setup.getTabClasses(tab2)], attrs: { "to": tab2.to, "native": tab2.native, "aria-disabled": tab2.disabled, "data-index": _setup.getTabDataIndex(tab2, index), "data-testid": _setup.getTabDataTestId(tab2), "target": _setup.getTabTarget(tab2), "aria-selected": `${tab2.active}`, "tabindex": _setup.getTabindex(tab2), "aria-controls": `panel-${tab2.name}`, "role": "tab" }, on: { "click": function($event) {
      return _setup.handleChangeTab(tab2, index, $event);
    }, "keydown": _setup.handleNavigationKeyboard } }, [!!(tab2 == null ? void 0 : tab2.icon) ? _c(_setup.XIcon, { attrs: { "icon": tab2.icon, "icon-style": tab2.iconStyle, "fixed-width": !_setup.isHorizontal, "data-testid": _setup.formatTestId(`${tab2.name}-tabIcon`) } }) : _vm._e(), _c(_setup.XEllipsis, { class: _vm.$style.tabTitle, attrs: { "id": `tab-${tab2.name}`, "data-testid": _setup.formatTestId(`${tab2.name}-tabText`) } }, [_vm._v(" " + _vm._s(tab2.title) + " ")]), _setup.hasTooltip(tab2) ? _c(_setup.XTooltip, { class: _vm.$style.tabTooltip, attrs: { "placement": _vm.tooltipPlacement, "data-testid": _setup.formatTestId(`${tab2.name}-tabTooltip`) }, scopedSlots: _vm._u([{ key: "activator", fn: function() {
      return [_c(_setup.XIcon, { attrs: { "icon": "question-circle", "fixed-width": !_setup.isHorizontal } })];
    }, proxy: true }], null, true) }, [_vm._v(" " + _vm._s(tab2.tooltipText) + " ")]) : _vm._e(), _vm._t(`after-title-${tab2.name}`), _vm._t("after-title", null, { "tab": tab2 })], 2);
  }), 1)])])], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XTabs = __component__.exports;
export {
  XTabs as default
};
